<template>
    <header>
        <div class="container">
            <div class="top-banner">
                <h1>Learn2Learn</h1>
                <h2>{{ siteTitle }}</h2>
                <p>{{ siteDesc }}</p>
                <p>
                    Search and browse through the lessons below. Select the appropriate lesson 
                    and click the Embed this lesson button to continue.
                </p>
                <p class="text-center">
                    <button @click="getStartedScroll()" class="btn btn-outline">Get Started <BIconChevronDown /></button>
                </p>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: "Header",
    props: ['siteTitle', 'siteDesc'],
    methods: {
        getStartedScroll(){
            document.querySelector('#main').scrollIntoView({ 
                behavior: 'smooth' 
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    header {
        background-color: var(--color-off-white);
        overflow: hidden;

        > .container, .top-banner {
            overflow: visible;
        }

    }

    .top-bar {
        background-color: var(--color-crimson);
        height: 70px;
    }

    .top-banner {
        padding: 64px 0;
        position: relative;
        z-index: 2;
    }
    h1 {
        font-size: 4.5rem;
        text-transform: uppercase;
    }
    h2 {
        font-size: 3.5rem;
    }
    p {
        width: 500px;
    }
    .btn {
        margin-top: 2rem;
        font-family: $fontBold;
        &:focus {
            box-shadow: none;
        }
        svg {
            font-size: 1.3rem;
            display: inline-block;
            margin-left: 0.5rem;
        }
    }

@media (min-width: 992px) {

    .top-banner {

        &:before {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            top: 0;
            right: -10%;
            background: url("../assets/header-white-bg.png") no-repeat right bottom;
            background-size: 100% auto;
            z-index: 0;
        }

        &:after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            top: 0;
            right: 0;
            background: url("../assets/header-image.svg") no-repeat right bottom;
            background-size: auto 90%;
            z-index: 1;
        }

    }

}
</style>